// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"873":"76401167","979":"ab0fcc96"}[chunkId] + ".css";
};